import clientDeepLinks from "@/utils/clientDeepLinks";
import { getCDNWithWebp } from "@/utils/getFullWebCdnUrl";
import handleDeepLink from "@/utils/handleDeepLink";
import { helpCenterLocaleHost } from "@/utils/util";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import useInApp from "@/hooks/useIsApp";
import React from "react";

const ServiceProvider = React.memo<{ style?: React.CSSProperties }>(
	({ style }) => {
		const { t } = useTranslation("common");
		const isInApp = useInApp();
		const router = useRouter();

		const handleDirectFree = () => {
			const url = `${helpCenterLocaleHost(router.locale)}/docs/fees/deposit-and-withdrawal-fees/`;
			if (isInApp) {
				handleDeepLink(clientDeepLinks.webview(url));
			} else {
				window.location.href = url;
			}
		};
		return (
			<div style={{ padding: "2rem 4px 5rem", ...style }}>
				<div className="flex flex-col items-center justify-center">
					<Image src={getCDNWithWebp("/deposit/rf-fsp.png")} width={32} height={26} alt="fsp" unoptimized />
					<p className=" mt-1.5 text-center text-xs text-_979eae">
						{t("RF-New-Zealand-licensed-broker", { ns: "rapyd" })}
					</p>
				</div>

				<div className="mt-5 flex justify-around">
					<div style={{ width: "50%" }}>
						<div className=" flex h-9 items-center justify-center">
							<Image src={getCDNWithWebp("/deposit/sipc.png")} width={58} height={24} alt="sipc" unoptimized />
						</div>
						<p className=" mt-2.5 text-center text-xs text-_979eae">{t("assets-protected-by-SIPC", { ns: "rapyd" })}</p>
					</div>

					<div style={{ width: "50%" }}>
						<div className="flex h-9 items-center justify-center">
							<Image src={getCDNWithWebp("/deposit/bank.png")} width={36} height={36} alt="bank" unoptimized />
						</div>
						<p className="mt-2.5 text-center text-xs text-_979eae">
							{t("funds-regulated-by-bank-of-China", { ns: "rapyd" })}
						</p>
					</div>
				</div>

				<div className="mt-4 text-[11px] leading-5 text-_979eae">{t("security-description")}</div>

				<div className="text-_979eae text-[11px] leading-5 mt-2.5">
					{t("fee-description")}
					<a
						className="text-[11px] font-normal text-primary underline underline-offset-2 focus:text-primary-active active:text-primary-active dark:text-white dark:font-bold"
						onClick={(e) => handleDirectFree()}
					>
						{t("rockflow-deposit-and-withdrawal")}
					</a>
				</div>
			</div>
		);
	},
	(prev, next) => prev.style === next.style,
);

ServiceProvider.displayName = "ServiceProvider";
export default ServiceProvider;
